import React, { /* useContext,  */useEffect } from 'react'

import { Rect, Circle, Group, Transformer } from 'react-konva'

import ImageElement from './ImageElement'

const Interior = ({ shapeProps, isSelected, onSelect, onChange, onContextMenu, grid }) => {
	const shapeRef = React.useRef()
	const trRef = React.useRef()

	const boundBoxFunc = (oldBox, newBox) => {
		const isTooSmall = (newBox.width < 5) || (newBox.height < 5)
		const thickness = oldBox.height > oldBox.width ? 'width' : 'height'
		const isWall = shapeProps.objectKind === 'wall' || shapeProps.objectKind === 'window'

		if ((shapeProps.shape === 'round') && (newBox.height !== newBox.width)) {
			return oldBox
		}

		if (isTooSmall || (isWall && newBox[thickness] !== oldBox[thickness])) {
			return oldBox
		}
		return newBox
	}

	useEffect(() => {
		if (isSelected) {
		// we need to attach transformer manually
			trRef.current.nodes([shapeRef.current])
			trRef.current.getLayer().batchDraw()
		}
	}, [isSelected])

	const getFillColorByShape = (shape) => {
		switch(shape.objectKind) {
			case 'window':
				return '#E3F5FF'
			case 'tree':
			case 'bush':
			case 'plant':
			case 'chair':
			case 'barChair':
			case 'sofa':
			case 'doorLeft':
			case 'doorRight':
			case 'doubleDoors':
				return 'transparent'
			default:
				return '#fff'
		}
	}
	
	const getStrokeColorByShape = (shape) => {
		switch(shape.objectKind) {
			case 'window':
				return '#9CDBFF'
			case 'tree':
			case 'bush':
			case 'plant':
			case 'chair':
			case 'barChair':
			case 'sofa':
			case 'doorLeft':
			case 'doorRight':
			case 'doubleDoors':
				return 'transparent'
			default:
				return '#434343'
		}
	}

	const getCornerRadiusByShape = (shape) => {
		switch(shape.objectKind) {
			case 'wall':
			case 'window':
				return 0
			case 'sofa':
				return 5
			default:
				return 2
		}
	}

	return (
		<>
			<Group
				x={shapeProps.positionLeft + shapeProps.width / 2}
				y={shapeProps.positionTop + shapeProps.height / 2}

				width={shapeProps.width}
				height={shapeProps.height}

				rotation={shapeProps.rotationDeg}
				offsetY={shapeProps.height / 2}
				offsetX={shapeProps.width / 2}

				draggable
				onClick={onSelect}
				onTap={onSelect}
				ref={shapeRef}
				onContextMenu={onContextMenu}
				onDragEnd={(e) => {
					const x = getPositionValue(e, 'x', grid, shapeProps)
					const y = getPositionValue(e, 'y', grid, shapeProps)
					e.target.to({ x: x + shapeProps.width / 2, y: y + shapeProps.height / 2 })
					onChange({
						...shapeProps,
						positionLeft: x,
						positionTop: y
					})
				}}
				onTransformEnd={(e) => {
					// transformer is changing scale of the node
					// and NOT its width or height
					// but in the store we have only width and height
					// to match the data better we will reset scale on transform end

					const node = shapeRef.current
					const scaleX = node.scaleX()
					const scaleY = node.scaleY()

					// we will reset it back
					node.scaleX(1)
					node.scaleY(1)

					let width = node.width()
					let height = node.height()
					let angle = node.rotation()

					const fieldsToUpdate = shapeProps.rotationDeg === angle ? {
						positionLeft: Number((node.x() - width * scaleX / 2).toFixed(0)),
						positionTop: Number((node.y() - height * scaleY / 2).toFixed(0)),
						// set minimal value
						width: Number(Math.max(5, width * scaleX).toFixed(0)),
						height: Number(Math.max(5, height * scaleY).toFixed(0))
					} : {
						rotationDeg: Math.round(angle)
					}

					onChange({
						...shapeProps,
						...fieldsToUpdate
					})
				}}
			>
				{['square', 'rectangle'].includes(shapeProps.shape) &&
					<Rect
						width={shapeProps.width}
						height={shapeProps.height}
						fill={getFillColorByShape(shapeProps)}
						cornerRadius={getCornerRadiusByShape(shapeProps)}
						stroke={getStrokeColorByShape(shapeProps)}
						strokeWidth={1}
					/>}
				{shapeProps.shape === 'round' &&
					<Circle
						radius={shapeProps.width / 2}
						fill={getFillColorByShape(shapeProps)}
						stroke={getStrokeColorByShape(shapeProps)}
						strokeWidth={1}
					/>}
				<ImageElement shapeProps={shapeProps} />
			</Group>
			{isSelected && (
				<Transformer
					ref={trRef}
					boundBoxFunc={boundBoxFunc}
				/>
			)}
		</>
	)
}

export default Interior

const getPositionValue = (e, value, grid, shapeProps) => {
	switch(shapeProps.objectKind) {
		case 'column':
			if (e.target[value]() < (shapeProps.width / 2)) {
				return shapeProps.width / 2
			}
			return e.target[value]()
		default:
			const res = Math.round((e.target[value]() - (shapeProps[value === 'x' ? 'width' : 'height'] / 2)) / grid) * grid
			if (res < 0) {
				return 0
			}
			return res
	}
}
